import { useMemo } from 'react';
import { useBusinessMeta, usePaymentsData } from '../../../contexts/dataContextSlices';

/**
 * Supermarket supplier payments + invoices slice (Strangler over DataContext).
 */
export function useSupermarketPaymentsDomain() {
  const meta = useBusinessMeta();
  const payments = usePaymentsData();

  return useMemo(
    () => ({
      ...payments,
      currentBusinessId: meta.currentBusinessId,
      ready: meta.ready,
      dataLoaded: meta.dataLoaded
    }),
    [meta, payments]
  );
}
